// @flow
// A few very old dependencies (e.g. react-shortcut) still call the
// React 15 APIs `React.createClass` / `React.PropTypes`, which were removed
// in React 16. Under the previous webpack/CRA setup this "worked" only
// because those packages ship their own nested react@15 copy, and webpack's
// default node_modules resolution picked that copy up for them. Vite/Rollup
// dedupe the `react` package to a single instance (required for hooks to
// work correctly), so that accidental nested-copy fallback no longer
// happens. This shim restores just enough of the removed API so those
// legacy packages keep working against React 16.
import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

if (!React.createClass) {
    React.createClass = createReactClass;
}

if (!React.PropTypes) {
    React.PropTypes = PropTypes;
}
